export enum INFINITE_SCROLL_EVENTER {
    UPDATE = 'infinite-scroll:update'
}


// WEBPACK FOOTER //
// ./common/src/main/resources/ts/core/enums/infinite-scroll-event.ts